import React, {
  Children,
  Component,
  Suspense,
  useEffect,
  useState
} from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet
} from "react-router-dom";

import { getIdToken, isLoggedIn } from "./webapi/AuthService";

import Sidebar from "./components/Sidebar";
import SignIn from "./SignIn";
import Activate from "./components/login/Activate";
import HeaderWrapper from "./components/HeaderWrapper";
import useDeviceDetection from "./components/hooks/useDeviceDetection";
import { getApiRolesForPerson } from "./webapi/webapi";
import { ToastContainer } from "react-toastify";

const UserSettings = React.lazy(() => import("./UserSettings"));
const Home = React.lazy(() => import("./Home"));
const Favorite = React.lazy(() => import("./Favorite"));
const Rundown = React.lazy(() => import("./Rundown"));
const MamWrapper = React.lazy(() => import("./MamWrapper"));
const Search = React.lazy(() => import("./Search"));
const Live = React.lazy(() => import("./Live"));
const Admin = React.lazy(() => import("./Admin"));
const AssetVideoPreview = React.lazy(() => import("./components/mam/AssetVideoPreview"));
const EntraLogin = React.lazy(() => import("./EntraLogin"));
const UploadDownload = React.lazy(() => import("./components/upload/UploadDownload"));
const PasswordReset = React.lazy(() => import("./components/login/PasswordReset"));
const ForgotPassword = React.lazy(() => import("./components/login/ForgotPassword"));

export const preloadRundown = () => import("./Rundown");
export const preloadSearch = () => import("./Search");

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

const MenuWrapper = props => {
  const style = {
    marginLeft: "125px",
    marginRight: "25px",
    marginTop: "25px"
  };

  const device = useDeviceDetection();

  if (device.isMobile) {
    style.marginLeft = "10px";
    style.marginRight = "10px";
  }

  return (
    <div>
      <HeaderWrapper />
      <Sidebar allPersonRoles={props.allPersonRoles} />
      <div className="container">
          <Suspense fallback={<ModuleLoading />}>
            <Outlet />
          </Suspense>
      </div>
    </div>
  );
};

const LogginWrapper = () => {
  return(
    <Suspense fallback={<ModuleLoading />}>
      <Outlet />
    </Suspense>

  )
}

class ModuleLoading extends Component {
  render() {
    return (
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    );
  }
}

const App = props => {
  const [allPersonRoles, setAllPersonRoles] = useState([]);

  useEffect(() => {
    if (isLoggedIn()) {
      fetchAllPersonRoles();
    }
  }, []);

  const fetchAllPersonRoles = () => {
    getApiRolesForPerson(parseInt(getIdToken(), 10)).then(roles => {
      let allRoles = [];

      roles.ApiGroupRoles.forEach(apiGroup => {
        apiGroup.ApiGroupRole.ProgramRoles.forEach(programRole => {
          programRole.Roles.forEach(role => {
            allRoles.push(role.RoleName);
          });
        });
        apiGroup.ApiGroupRole.ChannelRoles.forEach(channelRole => {
          channelRole.Roles.forEach(role => {
            allRoles.push(role.RoleName);
          });
        });
        apiGroup.ApiGroupRole.AssetGroupRoles.forEach(assetGroupRole => {
          assetGroupRole.Roles.forEach(role => {
            allRoles.push(role.RoleName);
          });
        });
        apiGroup.ApiGroupRole.GroupRoles.forEach(groupRole => {
          allRoles.push(groupRole.RoleName);
        });
      });

      const uniqueRoles = Array.from(new Set(allRoles));
      setAllPersonRoles(uniqueRoles);
    });
  };

  return (
    <>
      <Router>
        <ToastContainer
          position="bottom-right"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
          <Routes>
            <Route element={<LogginWrapper />}>
              <Route path="/preview" element={<AssetVideoPreview {...props} />} />
              <Route path="/activate" element={<Activate {...props} />} />
              <Route
                path="/passwordreset"
                element={<PasswordReset {...props} />}
              />
              <Route
                path="/forgotpassword"
                element={<ForgotPassword {...props} />}
              />
              <Route path="/signin" element={<SignIn {...props} />} />
              <Route path="entralogin" element={<EntraLogin {...props} />} />
            </Route>
            <Route
              element={
                <MenuWrapper {...props} allPersonRoles={allPersonRoles} />
              }
              path={"*"}
            >
              <Route
                path="mam/*"
                element={
                  <React.Fragment>
                    <MamWrapper {...props} />
                  </React.Fragment>
                }
              />
              <Route
                path=""
                element={<Home allPersonRoles={allPersonRoles} {...props}/>}
              />
              <Route
                path="usersettings"
                element={<UserSettings {...props} />}
              />
              <Route path="favorite" element={<Favorite {...props} />} />
              <Route path="rundown/*" element={<Rundown {...props} />} />
              <Route path="search/*" element={<Search {...props} />} />
              <Route path="live" element={<Live {...props} />} />
              <Route path="admin/*" element={<Admin {...props} allPersonRoles={allPersonRoles}/>} />
              <Route path="uploads" element={<UploadDownload {...props} />} />
            </Route>
          </Routes>
      </Router>
    </>
  );
};

export default App;
